import { ReactElement, useMemo, useCallback } from 'react';
import { faVectorSquare as LogisticsZonesIcon } from '@fortawesome/free-solid-svg-icons';

import { RouteReportCollectedItemsZone } from '~services/route/report/types';
import TrackingInTransitDeliveriesList from '~components/TrackingInTransitDeliveriesList';
// eslint-disable-next-line max-len
import { TrackingInTransitDeliveriesItemBase } from '~components/TrackingInTransitDeliveriesList/types';

import { useDashboardVariantV2CarrierContentCollectTrackingContext } from '../../../Context';

type ZonesDeliveryExtraData = Pick<RouteReportCollectedItemsZone, 'zoneId'>;

const DashboardVariantV2CarrierContentCollectTabTrackingSelectionTabZones =
  (): ReactElement => {
    const {
      tabsData: {
        data: tabsData,
        selectedZoneId: { value: selectedZoneId, setValue: setSelectedZoneId },
      },
    } = useDashboardVariantV2CarrierContentCollectTrackingContext();

    const zonesDeliveryData = useMemo<
      TrackingInTransitDeliveriesItemBase<ZonesDeliveryExtraData>[]
    >(() => {
      if (!tabsData?.collectedItemsByZone) return [];

      return tabsData.collectedItemsByZone.map((zone) => ({
        label: zone.zoneName,
        totalCount: zone.totalCollected,
        standarCount: zone.totalCollectedNoFlex,
        flexCount: zone.totalCollectedFlex,
        icon: {
          element: LogisticsZonesIcon,
          color: zone.color,
        },
        extraData: { zoneId: zone.zoneId },
        isSelected: selectedZoneId === zone.zoneId,
      }));
    }, [tabsData?.collectedItemsByZone, selectedZoneId]);

    const handleClickItem = useCallback(
      (extraData: ZonesDeliveryExtraData) => {
        setSelectedZoneId(extraData.zoneId);
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [],
    );

    return (
      <TrackingInTransitDeliveriesList
        data={zonesDeliveryData}
        onClickItem={handleClickItem}
      />
    );
  };

export default DashboardVariantV2CarrierContentCollectTabTrackingSelectionTabZones;
